// since hsvideo MUST have live_embeds, we can check for only those classes and not the placeholder ones too
export const isEditableVideo = (editor, node) => {
  if (!node) return false;
  return editor.settings.media_live_embeds === true && editor.dom.hasClass(node, 'mce-preview-object') && editor.dom.hasClass(node, 'hs-video');
};